import { lazy } from 'react'
const InternalExamBundles = lazy(() => import('./AssignedBundles'))
const InternalExamBundleView = lazy(() => import('./BundleView'))
const InternalExamEvaluation = lazy(() => import('./Evaluation'))
export { InternalExamBundleView, InternalExamBundles, InternalExamEvaluation }
